import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <AgitationSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <ValueStack data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FinalCTA data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}